import { LoaderProgress } from "components/icon/loaderProgress.component";
import { H3 } from "components/Typography/text.styled";
import { useAuthStore } from "stores/authStore/authStore";

export const SchedulePage = () => {
  const [authState] = useAuthStore();

  return authState.isLoading ? <LoaderProgress /> : <H3>Schedule</H3>;
};
